import React, { useState, useEffect } from 'react';
import { XMarkIcon, ArrowUpTrayIcon, PlusSquareIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const IOSInstallPrompt = () => {
  const { t } = useTranslation();
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // This is the key for iOS: window.navigator.standalone
  const isInstalled = window.navigator.standalone === true;

  if (isIOS && !isInstalled) {
    setIsShown(true);
  }
  }, []);
  
  if (!isShown) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] animate-fade-in-up">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 relative">
        <button 
          onClick={() => setIsShown(false)}
          className="absolute top-2 right-2 text-gray-400"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-4">
          <div className="bg-blue-600 rounded-xl p-2 text-white shrink-0">
            {/* Replace with your actual App Logo */}
            <span className="font-bold text-lg">PWA</span>
          </div>
          
          <div className="pr-6">
            <p className="text-sm font-bold text-gray-800">{t('general.install-prompt.title')}</p>
            <p className="text-xs text-gray-500 leading-tight">
              {t('general.install-prompt.tap')} <ArrowUpTrayIcon className="h-4 w-4 inline mb-1 text-blue-500" /> {t('general.install-prompt.share-then')}
              <span className="font-semibold"> {t('general.install-prompt.add-to-home')}</span>.
            </p>
          </div>
        </div>
      </div>
      
     <div className="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-white mx-auto drop-shadow-md"></div>
    </div>
  );
};

export default IOSInstallPrompt;
